// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24Aw-","productName":"Table_productName__1CJF5"};